import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject, input } from '@angular/core';

import { ButtonModule, IconModule, WithDigitGroupsPipe } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { CopyTooltipComponent, StatusComponent } from '@kr/components';
import { ProviderIconComponent } from '@kr/components/provider-icon/provider-icon.component';
import { CommentDialog } from '@kr/components/transactions/components';
import { Transaction, TransactionType, Wallet } from '@kr/models';
import { CurrencyBalanceFormatPipe } from '@kr/pipes';
import { ClipboardService } from '@kr/services';

import { TransactionsStore } from '../../transactions.store';
import { TransactionCommentForm } from './components/comment-dialog/comment-dialog.component';

@Component({
  imports: [
    CommonModule,
    TranslateModule,
    IconModule,
    ButtonModule,
    StatusComponent,
    CopyTooltipComponent,
    WithDigitGroupsPipe,
    CurrencyBalanceFormatPipe,
    ProviderIconComponent,
  ],
  selector: 'kr-transaction, [krTransaction]',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionComponent {
  readonly #commentDialog = inject(CommentDialog);
  readonly #store = inject(TransactionsStore);
  readonly clipboard = inject(ClipboardService);

  readonly TransactionType = TransactionType;

  transaction = input.required<Transaction>();
  wallet = input<Wallet>();
  isolated = input<boolean>(false);

  @HostBinding('class.kr-transaction_isolated') get isolatedClass() {
    return !!this.isolated();
  }

  get depositTransaction(): boolean {
    return this.transaction().trTypeString === 'deposit' || this.transaction().trTypeString === 'internal_deposit';
  }

  get payoutTransaction(): boolean {
    return this.transaction().trTypeString === 'payout' || this.transaction().trTypeString === 'internal_payout';
  }

  get secondaryCoinUnicode(): string {
    return this.transaction()?.coin?.secondaryCoin?.coinUnicode ?? this.transaction()?.coin?.coinUnicode ?? '';
  }

  openCommentDialog(event: Event) {
    event.stopPropagation();
    this.#commentDialog
      .open(this.transaction(), this.wallet())
      .afterClosed<TransactionCommentForm>()
      .subscribe(value => {
        if (value) {
          this.#store.saveComment(value);
        }
      });
  }
}
